import React, { useState } from "react";
import { Typography, Grid, Box } from "@mui/material";
import { LedgerTable } from "../components/LedgerTable/LedgerTable";
import BarComponent from "../components/BarComponent/BarComponent";
import { useAccelContext } from "../contexts/AccelContext/AccelContext";
import AccountingJournal from "../components/AccountingJournal/AccountingJournal";
import ClosedBooksMonthly from "../components/ClosedBooksMonthly/ClosedBooksMonthly";

export const LedgerView = () => {
  const [toggleType, setToggleType] = useState("chart_of_accounts");
  const [accountingJournals, setAccountingJournals] = useState([]);

  const { theme, authErrorState, generalLedger } = useAccelContext();
  const values = [{ value: "chart_of_accounts", label: "Chart of Accounts" }];

  if (authErrorState) {
    return null;
  }

  const renderContent = () => {
    switch (toggleType) {
      case "chart_of_accounts":
        return <LedgerTable />;
      case "accounting_journals":
        return <AccountingJournal />;
      case "closed_books":
        return <ClosedBooksMonthly />;
      default:
        return null;
    }
  };

  return (
    <Box sx={{ height: "100vh", width: "100vh" }}>
      <Grid container spacing={2}>
        <Grid
          item
          container
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: "row",
            paddingLeft: 2,
          }}
          width="100%"
          spacing={2}
        >
          <Box sx={{ py: 1, pl: 2 }}>
            <Typography
              variant="h5"
              component="div"
              sx={{
                color: theme?.text?.hex,
                fontSize: 41,
                fontFamily: "Helvetica Neue",
              }}
            >
              General Ledger
            </Typography>
          </Box>
        </Grid>
        <Grid item width="100%">
          <BarComponent
            values={values}
            toggleType={toggleType}
            setToggleType={setToggleType}
            showToggleGroup={true}
            showDownloadButton={true}
            onDownload={() => {
              const fileUrl = generalLedger?.pdf_url;
              if (fileUrl) {
                // Create a temporary anchor element
                const link = document.createElement('a');
                link.href = fileUrl;
                // Set the download attribute with a filename
                link.download = 'general_ledger.pdf';
                // Append to the body, click, and remove
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
            }}
            showDatePicker={true}
            showButtons={true}
            showSearchBar={false}
          />
        </Grid>
        <Grid item width="100%">
          <Box
            sx={{
              height: "700px",
              width: "100%",
              alignItems: "start",
            }}
          >
            {renderContent()}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LedgerView;
